import { AppyError } from '../../../../../../Appy';
import { MissingLinkError } from '../../../../../../LinkyLinky';
import { LearningCollectionResource } from '../../../../Types';

export interface Waiting {
  kind: 'waiting';
  learningCollectionResource: LearningCollectionResource;
}

export interface Ready {
  kind: 'ready';
  learningCollectionResource: LearningCollectionResource;
}

export interface Creating {
  kind: 'creating';
  learningCollectionResource: LearningCollectionResource;
}

export interface Error {
  kind: 'error';
  error: ShareUrlError;
  learningCollectionResource: LearningCollectionResource;
}

export type ShareUrlError = AppyError | MissingLinkError;

export type State = Waiting | Ready | Creating | Error;

export const waiting = (learningCollectionResource: LearningCollectionResource): Waiting => ({
  kind: 'waiting',
  learningCollectionResource,
});

export const ready = (learningCollectionResource: LearningCollectionResource): Ready => ({
  kind: 'ready',
  learningCollectionResource,
});

export const creating = (state: Waiting | Ready): Creating => ({
  kind: 'creating',
  learningCollectionResource: state.learningCollectionResource,
});

export const error = (error: ShareUrlError, state: Waiting | Ready | Creating): Error => ({
  kind: 'error',
  learningCollectionResource: state.learningCollectionResource,
  error,
});
